/**
 *
 * @param word label string
 * @returns count of label string
 */
export const labelWordCount = (word: any): number => {
  return word.split(" ").length;
};
//Description box style
export const descriptionBoxStyle = {
  display: "block",
};
//reload the window whenever user resize the window
export const handleResize = () => {
  window.location.reload();
};